var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttached(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2934 7.3575L8.1667 13.4842C7.41613 14.2347 6.39815 14.6564 5.3367 14.6564C4.27524 14.6564 3.25726 14.2347 2.5067 13.4842C1.75613 12.7336 1.33447 11.7156 1.33447 10.6542C1.33447 9.59271 1.75613 8.57473 2.5067 7.82416L8.63336 1.6975C9.13374 1.19712 9.81239 0.916016 10.52 0.916016C11.2277 0.916016 11.9063 1.19712 12.4067 1.6975C12.9071 2.19787 13.1882 2.87653 13.1882 3.58416C13.1882 4.2918 12.9071 4.97046 12.4067 5.47083L6.27336 11.5975C6.02318 11.8477 5.68385 11.9882 5.33003 11.9882C4.97621 11.9882 4.63688 11.8477 4.3867 11.5975C4.13651 11.3473 3.99596 11.008 3.99596 10.6542C3.99596 10.3003 4.13651 9.96102 4.3867 9.71083L10.0467 4.0575",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttached);
export default __webpack_public_path__ + "static/media/attached.8993a5b6e7de019ee165dc22e82cad79.svg";
export { ForwardRef as ReactComponent };